import { ConfigBlock } from './BlockTypes';

const requireContext = require.context('../blocks', false, /\.block\.tsx$/);
export const allBlocks = new Map<string, ConfigBlock>(
    requireContext
        .keys()
        .map(path => ([path.replace("./", ""), requireContext(path).default]))
)
